import { usersAxios } from 'services/controllers/users';

import * as t from './types';

export const UsersApi = {
  login: async (payload: t.ILoginPayload) => {
    const { data } = await usersAxios.post<t.ILoginResponse>('/login', payload);
    return data;
  },

  logout: async () => {
    const { data } = await usersAxios.post('/logout');
    return data;
  },

  delete: async () => {
    const { data } = await usersAxios.delete('');
    return data;
  },

  updateUserEmail: async (payload: t.IUpdateUserEmailPayload) => {
    const { data } = await usersAxios.put<t.IRegisterResponse>('/change-email', payload);
    return data;
  },

  register: async (payload: t.IRegisterPayload) => {
    const { data } = await usersAxios.post<t.IRegisterResponse>('/register', payload);
    return data;
  },

  verifyEmail: async (params: t.IVerifyEmailPayload) => {
    const { data } = await usersAxios.get<t.IVerifyEmailResponse>('/verify-email', { params });
    return data;
  },

  getUserDetails: async () => {
    const { data } = await usersAxios.get<t.IUserDetails>('/details');
    return data;
  },

  putUserDetails: async (payload: t.IUserDetails) => {
    const { data } = await usersAxios.put<t.IUserDetails>('/details', payload);
    return data;
  },

  verifyAccess: async (payload: t.ITempLogin) => {
    await usersAxios.post('/temp-login', payload);
  }
};
